import React from 'react';
import { BiDollar, BiHide } from 'react-icons/bi';
import { BsPersonFill } from 'react-icons/bs';
import {
  FaBox,
  FaCalculator,
  FaFileInvoiceDollar,
  FaTruck,
} from 'react-icons/fa';
import { HiClipboardList } from 'react-icons/hi';
import { useEntradaNFE } from '../../EntradaNFEContext';
import {
  CardContainer,
  DescriptionContainer,
  MessageContainer,
  TypeContainer,
  TypeIcon,
} from './styles';
import { LuExternalLink } from 'react-icons/lu';
import { formatCurrencyAsText } from '~/utils/functions';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { AiOutlineCheck } from 'react-icons/ai';

interface CardCriticasProps {
  type: number;
  title: string;
  message: string;
  show: boolean;
  calculatedValue: number;
  fieldName: string;
}

interface TabType {
  tab: string;
  label: string;
}

/**
 *
 * @param type
 * 0 - Capa
 * 1 - Item
 * 2 - Financeiro
 * 3 - Guia
 * 4 - ICMS
 * 5 - Frete
 * 6 - Fornecedor
 */

export const CardCritica: React.FC<CardCriticasProps> = ({
  type,
  title,
  message,
  show,
  calculatedValue,
  fieldName,
}) => {
  const { formNfe, criticas, setCriticas, setCurrentTab } = useEntradaNFE();
  const getIcon = () => {
    switch (type) {
      // Item
      case 1: {
        return <FaBox />;
      }
      // Financeiro
      case 2: {
        return <BiDollar />;
      }
      // Guia
      case 3: {
        return <FaFileInvoiceDollar />;
      }
      // ICMS
      case 4: {
        return <FaCalculator />;
      }
      // Frete
      case 5: {
        return <FaTruck />;
      }
      // Fornecedor
      case 6: {
        return <BsPersonFill />;
      }
      // Capa
      default: {
        return <HiClipboardList />;
      }
    }
  };
  const getTitleType = () => {
    switch (type) {
      case 1: {
        return 'Item';
      }
      case 2: {
        return 'Financeiro';
      }
      case 3: {
        return 'Guia';
      }
      case 4: {
        return 'ICMS';
      }
      case 5: {
        return 'Frete';
      }
      case 6: {
        return 'Fornecedor';
      }
      default: {
        return 'Capa';
      }
    }
  };

  const formatMessage = () => {
    const splittedMessage = message.split(`\n`);
    const formatedMessage = splittedMessage.map((part) => {
      return <span>{part}</span>;
    });
    return formatedMessage;
  };

  const handleAssumirValorCalculado = () => {
    formNfe.setValue(fieldName, formatCurrencyAsText(calculatedValue));
    const criticasFiltered = criticas.filter(
      (item) => item.title !== title && fieldName !== item.fieldName,
    );
    setCriticas(criticasFiltered);
  };

  const tabMap: { [key: number]: TabType } = {
    1: { tab: 'nfe', label: 'Item' },
    2: { tab: 'financeiro', label: 'Financeiro' },
    3: { tab: 'guia', label: 'Guia' },
    5: { tab: 'produtor', label: 'Frete' },
    6: { tab: 'produtor', label: 'Fornecedor' },
  };

  const handleIrParaAba = () => {
    const { tab, label } = tabMap[type] || { tab: 'nfe', label: undefined };
    setCurrentTab(tab);
    return label;
  };

  return (
    <>
      {show && (
        <CardContainer>
          <MessageContainer>
            <TypeContainer>
              <span>{getTitleType()}</span>
              <TypeIcon>{getIcon()}</TypeIcon>
            </TypeContainer>
            <DescriptionContainer>
              <strong>{title}</strong>
              {formatMessage()}
            </DescriptionContainer>
          </MessageContainer>
          {(type === 4 || type === 1) && (
            <CustomButtonNovo
              label="Assumir Valor"
              iconPosition="right"
              icon={AiOutlineCheck}
              onClick={handleAssumirValorCalculado}
            />
          )}
          {type !== 4 && type !== 1 && (
            <CustomButtonNovo
              label="Ir para Aba"
              iconPosition="right"
              icon={LuExternalLink}
              onClick={handleIrParaAba}
            />
          )}
        </CardContainer>
      )}
    </>
  );
};
